import Footer from "components/footer/FooterAuthDefault";
import { t } from "i18next";
import useWhiteLabel from "whitelabel/useWhiteLabel";

function Default(props: { maincard: JSX.Element }) {
  const { maincard } = props;
  const { images } = useWhiteLabel();
  return (
    <div className="relative min-h-screen bg-background-950">
      <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
        <div className="mx-auto block h-40 pb-4 pt-6 lg:hidden">
          <img src={images.AUTH_LOGO} alt="Overlay" className="px-10" />
        </div>
        <div className="col-span-1 flex flex-col px-6 py-0 pt-0 md:px-28 lg:justify-center lg:px-24 2xl:px-40 3xl:px-52">
          {maincard}
        </div>
        <div className="hidden lg:block">
          {/* Background image and logo for larger screens */}
          <div className="relative flex h-full w-full">
            <div
              style={{ backgroundImage: `url(${images.AUTH_BACKGROUND})` }}
              className="relative h-screen w-full bg-cover bg-center"
            />
            <div className="absolute left-0 top-28 z-0 flex h-full w-full flex-col items-center  gap-5">
              <img
                src={images.AUTH_LOGO}
                alt="Overlay"
                className="max-h-72 px-20"
              />
              <div className="mt-10 flex flex-col items-center">
                <p className="fixed-plugin mb-2">
                  {t("auth.fixed.plugin.line1", { ns: "whitelabel" })}
                </p>
                <p className="fixed-plugin mb-2">
                  {t("auth.fixed.plugin.line2", { ns: "whitelabel" })}
                </p>
                <p className="fixed-plugin">
                  {" "}
                  {t("auth.fixed.plugin.line3", { ns: "whitelabel" })}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="z-10 mt-4 w-full md:absolute md:bottom-0">
        <Footer />
      </div>
    </div>
  );
}

export default Default;
